import { CLICK_ID_KEY, REWARDS_PARTNER_KEY } from 'constants/impact';
import locator from 'utils/locator';
import { stashObject } from 'utils/stash';

export const stashImpactValues = () => {
  const urlParams = new URLSearchParams(locator.search);
  const irclickid = urlParams.get('irclickid');
  const imRewards = urlParams.get('im_rewards');

  if (irclickid) {
    stashObject(CLICK_ID_KEY, irclickid);
  }

  if (imRewards === '1') {
    stashObject(REWARDS_PARTNER_KEY, '1');
  }
};
